export const Data = [
  {
    type: "zh",
    imgBoxUrl:"https://www.victrum.com/image/tp/联系我们banner.png",
    numList : [
      {
        num : "1",
        tital : "中国北京",
        path:"zgbj"
      },
      {
        num : "2",
        tital : "中国苏州",
        path:"zgsz"
      }
    ],
    item1:{
      imgUrl:"https://www.victrum.com/image/nr/lxwm/bj.png",
      text1:"地址",
      text2:"北京市顺义区马坡镇聚源中路12号院11号楼201、202",
      text3:"电话",
      text4:"010-56467587",
      text5:"邮箱",
      text6:"victrum0430@gmail.com"
    },
    item2:{
      imgUrl:"https://www.victrum.com/image/nr/lxwm/sz.png",
      text1:"地址",
      text2:"江苏省苏州市吴中区郭巷尹山湖路 999 号吴中生物医药产业园一期 A 幢一层",
      text3:"电话",
      text4:"400-178-1617",
      text5:"邮箱",
      text6:"victrum0430@gmail.com"
    }
  },
  {
    type: "en",
    imgBoxUrl:"https://www.victrum.com/image/tp/联系我们banner.png",
    numList : [
      {
        num : "1",
        tital : "Beijing, China",
        path:"zgbj"
      },
      {
        num : "2",
        tital : "Suzhou, China",
        path:"zgsz"
      }
    ],
    item1:{
      imgUrl:"https://www.victrum.com/image/nr/lxwm/bj.png",
      text1:"Address",
      text2:"Building 11, Units 201 & 202, No. 12 Courtyard, Juyuan Middle Road, Mapo Town, Shunyi District, Beijing, China",
      text3:"Phone",
      text4:"+86 010-56467587",
      text5:"Email",
      text6:"victrum0430@gmail.com"
    },
    item2:{
      imgUrl:"https://www.victrum.com/image/nr/lxwm/sz.png",
      text1:"Address",
      text2:"1st Floor, Building A, Phase 1, Wuzhong Biopharmaceutical Industrial Park, No. 999 Yinshanhu Road, Guoxiang, Wuzhong District, Suzhou, Jiangsu, China",
      text3:"Phone",
      text4:"400-178-1617",
      text5:"Email",
      text6:"victrum0430@gmail.com"
    }
  }
]



// WEBPACK FOOTER //
// ./src/components/js/contactUs.js